import { useEffect } from 'react'

export const IMPORT_SESSION_RESTORE_KEY = 'audience-import:restore-target'

export function readImportSessionRestoreBeacon(): {
  sessionId: string
  route: string
  touchedAt: number
} | null {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    const raw = window.sessionStorage.getItem(IMPORT_SESSION_RESTORE_KEY)
    if (!raw) {
      return null
    }
    const parsed = JSON.parse(raw) as {
      sessionId?: string
      route?: string
      touchedAt?: number
    }
    if (
      typeof parsed.sessionId !== 'string' ||
      typeof parsed.route !== 'string' ||
      typeof parsed.touchedAt !== 'number'
    ) {
      return null
    }
    return {
      sessionId: parsed.sessionId,
      route: parsed.route,
      touchedAt: parsed.touchedAt,
    }
  } catch {
    return null
  }
}

export function clearImportSessionRestoreBeacon() {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.sessionStorage.removeItem(IMPORT_SESSION_RESTORE_KEY)
  } catch {
    // Best-effort only.
  }
}

export function useImportSessionRestoreBeacon(args: {
  sessionId: string | null | undefined
  route: string | null | undefined
  machineState: string | null | undefined
}) {
  useEffect(() => {
    if (!args.sessionId || !args.route) {
      return
    }
    if (
      args.machineState === 'completed' ||
      args.machineState === 'expired' ||
      args.machineState === 'discarded'
    ) {
      clearImportSessionRestoreBeacon()
      return
    }
    try {
      window.sessionStorage.setItem(
        IMPORT_SESSION_RESTORE_KEY,
        JSON.stringify({
          sessionId: args.sessionId,
          route: args.route,
          touchedAt: Date.now(),
        }),
      )
    } catch {
      // Best-effort only.
    }
  }, [args.machineState, args.route, args.sessionId])
}
